import Swal from "sweetalert2";
import axios from "axios";
import router from "@/router";
import {months, shortMonths} from "@/helpers/consts";

export function fieldToName(field) {
  if (typeof field === 'string') {
    return field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }
  return field; // Fallback if it's not a string
}

export const fetchLanguages = async (query) => {
  // From: https://www.back4app.com/database/paul-datasets/list-of-all-programming-languages/get-started/javascript/rest-api/fetch?objectClassSlug=dataset

  console.log('query', query)

  let where = ''

  if (query) {
    where = '&where=' + encodeURIComponent(JSON.stringify({
      "ProgrammingLanguage": {
        "$regex": `${query}|${query.toUpperCase()}|${query[0].toUpperCase() + query.slice(1)}`
      }
    }))
  }

  const response = await fetch(
      'https://parseapi.back4app.com/classes/All_Programming_Languages?limit=9999&order=ProgrammingLanguage&keys=ProgrammingLanguage' + where,
      {
        headers: {
          'X-Parse-Application-Id': 'XpRShKqJcxlqE5EQKs4bmSkozac44osKifZvLXCL', // This is the fake app's application id
          'X-Parse-Master-Key': 'Mr2UIBiCImScFbbCLndBv8qPRUKwBAq27plwXVuv', // This is the fake app's readonly master key
        }
      }
  );

  const data = await response.json(); // Here you have the data that you need

  return data.results.map((item) => {
    return {value: item.ProgrammingLanguage, label: item.ProgrammingLanguage}
  })
}

export const fetchData = ({url, filters = {}, onSuccess = null, onError = null}) => {
  let newHeader = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`
    }
  };
  const requestFilters = {
    ...(filters || {}),
    realmId: sessionStorage.getItem('realmId')
  };
  axios.post(url, requestFilters, newHeader)
      .then(res => {
        if (typeof onSuccess === 'function') {
          onSuccess(res.data)
        }
        else {
          console.log(res)
        }
      })
      .catch(error => {
        if (error.status === 401) {
          console.log('401 received')
          return
        }
        if (typeof onError === 'function') {
          onError(error)
        }
        else {
          console.log(error);
        }
      });
}

export const fetchDataWithResponseType = ({url, filters, responseType = "json", onSuccess = null, onError = null}) => {
  let newHeader = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
    },
    responseType: responseType, // Set response type dynamically
  };

  axios
      .post(url, filters, newHeader)
      .then((res) => {
        if (typeof onSuccess === "function") {
          onSuccess(res.data);
        }
        else {
          console.log(res);
        }
      })
      .catch((error) => {
        if (typeof onError === "function") {
          onError(error);
        }
        else {
          console.log(error);
        }
      });
};


export const fetchFormData = ({url, filtersDto, onSuccess = null, onError = null}) => {
  let newHeader = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`
    }
  };
  axios.post(url, filtersDto, newHeader)
      .then(res => {
        if (typeof onSuccess === 'function') {
          onSuccess(res.data)
        }
        else {
          console.log(res)
        }
      })
      .catch(error => {
        if (error.status === 401) {
          console.log('401 received')
          return
        }
        if (typeof onError === 'function') {
          onError(error)
        }
        else {
          console.log(error);
        }
      });
}

// eslint-disable-next-line no-unused-vars
function replaceCharacters(str, charsToReplace, replacement) {
  // Create a regular expression from the list of characters
  let regex = new RegExp(`[${charsToReplace}]`, 'g');
  // Replace all occurrences of the characters with the replacement
  return str.replace(regex, replacement);
}

export const postData = ({
                           url,
                           data,
                           noticeMessageTitle = "Submit this form",
                           noticeMessage = null,
                           onSuccess = null,
                           onError = null,
                           onComplete = null,
                           callBackUrl = null,
                           onCancel = null,
                           callbackWithFullResponse = false
                         }) => {
  if (data) {
    data.realmId = sessionStorage.getItem('realmId')
  }
  Swal.fire({
    title: noticeMessageTitle,
    icon: "question",
    text: noticeMessage,
    showCancelButton: true,
    confirmButtonText: "Yes, Go ahead",
    cancelButtonText: "No, cancel!",
    showLoaderOnConfirm: true,
    confirmButtonColor: "#387173",
    cancelButtonColor: "#ff7f41",
    reverseButtons: true,
    preConfirm: async () => {
      try {
        const jwt = sessionStorage.getItem("jwt");
        const headers = {
          Authorization: `Bearer ${jwt}`,
        };
        const response = await axios.post(url, data, {headers});

        if (!response || !response.data) {
          throw new Error("No response data received from the server.");
        }

        return response.data;
      }
      catch (error) {
        if (error.status === 401) {
          console.log('401 received')
          return
        }
        console.error("Request failed:", error.response.data);

        // 🛠️ **Fix: Always return a valid object, even on errors**
        const errorData = error.response.data ?? {
          responseCode: "ERROR",
          responseMessage: error.response.data.status === 401
              ? "Unauthorized access. Please log in."
              :
              error.response.data.status === 500
                  ? "Application Error!"
                  :
                  error.response.data.status === 403
                      ? "Access Forbidden!"
                      : "An unknown error occurred"
          ,
        };
        if (typeof onError === "function") {
          onError(error);
        }
        else {
          await Swal.fire({
            icon: "error",
            title: "Error!",
            text: errorData.responseMessage,
          });
        }

        return errorData;
      }
    },
    allowOutsideClick: false,
  })
      .then((result) => {
        if (result.isConfirmed && result.value) {
          const resData = result.value;

          //if (resData.responseCode && resData.responseCode === "SUCCESS") {
          if (resData.responseCode === "SUCCESS") {

            if (typeof onSuccess === "function") {
              if (callbackWithFullResponse) {
                onSuccess(resData)
              }
              else {
                onSuccess(resData.data);
              }
            }
            else if (typeof onComplete === "function") {
              onComplete();
            }
            else if (callBackUrl) {
              router.push({name: callBackUrl});
            }
            else {
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: resData.responseMessage,
              });
            }
          }
          else {
            Swal.fire({
              icon: "warning",
              title: "System error!",
              text: resData.responseMessage || "An unknown error occurred.",
            }).then(() => {
              if (typeof onError === "function") {
                onError(resData);
              }
            });
          }
        }
        else if (result.dismiss) {
          if (typeof onCancel === "function") {
            onCancel(result.dismiss);
          }
        }
        else {
          console.log("No valid data returned from the request.");
        }
      })
      .catch((err) => {
        console.error("Unexpected error:", err);
      });
};


export const postDataWithoutAlerts = ({
                                        url,
                                        data,
                                        onSuccess = null,
                                        onError = null,
                                        onComplete = null,
                                        callBackUrl = null,
                                      }) => {
  const sendRequest = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
      };
      const response = await axios.post(url, data, {headers});

      if (typeof onSuccess === "function") {
        onSuccess(response.data);
      }
      else {
        console.log(JSON.stringify(response.data, null, 2));
      }
      return response.data; // Return the response data
    }
    catch (error) {
      if (error.status === 401) {
        console.log('401 received')
        
        return
      }
      if (typeof onError === "function") {
        onError(error);
      }
      console.error(error.message);
      return null; // Return null to indicate an error
    }
  };

  sendRequest()
      .then((resData) => {
        if (resData && resData.responseCode === "SUCCESS") {
          if (typeof onComplete === "function") {
            onComplete();
          }
          else if (callBackUrl) {
            router.push({name: callBackUrl});
          }
          else {
            console.log("Operation successful", resData.responseMessage);
          }
        }
        else if (resData) {
          console.warn("Validation error", resData.responseMessage);
        }
        else {
          console.log("No data returned from the request.");
        }
      })
      .catch((err) => {
        console.error("Unexpected error:", err);
      });
};

export const postDataWithoutAlertsNoHeader = ({
                                                url,
                                                data,
                                                onSuccess = null,
                                                onError = null,
                                                onComplete = null,
                                                callBackUrl = null,
                                              }) => {
  const sendRequest = async () => {
    try {
      const response = await axios.post(url, data);

      if (typeof onSuccess === "function") {
        onSuccess(response.data);
      }
      else {
        console.log(JSON.stringify(response.data, null, 2));
      }
      return response.data; // Return the response data
    }
    catch (error) {
      if (error.status === 401) {
        console.log('401 received')
        
        return
      }
      if (typeof onError === "function") {
        onError(error);
      }
      console.error(error.message);
      return null; // Return null to indicate an error
    }
  };

  sendRequest()
      .then((resData) => {
        if (resData && resData.responseCode === "SUCCESS") {
          if (typeof onComplete === "function") {
            onComplete();
          }
          else if (callBackUrl) {
            router.push({name: callBackUrl});
          }
          else {
            console.log("Operation successful", resData.responseMessage);
          }
        }
        else if (resData) {
          console.warn("Validation error", resData.responseMessage);
        }
        else {
          console.log("No data returned from the request.");
        }
      })
      .catch((err) => {
        console.error("Unexpected error:", err);
      });
};

export const postUpload = ({url, data, onSuccess = null, onError = null, onComplete = null, callBackUrl = null,}) => {
  const sendRequest = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
      };
      const response = await axios.post(url, data, {headers});

      if (typeof onSuccess === "function") {
        onSuccess(response);
      }
      else {
        console.log(JSON.stringify(response, null, 2));
      }
      return response; // Return the response data
    }
    catch (error) {
      if (error.status === 401) {
        console.log('401 received')
        
        return
      }
      if (typeof onError === "function") {
        onError(error);
      }
      console.error(error.message);
      return null; // Return null to indicate an error
    }
  };

  sendRequest()
      .then((resData) => {
        if (resData && resData.data.responseCode === "SUCCESS") {
          if (typeof onComplete === "function") {
            onComplete(resData.data);
          }
          else if (callBackUrl) {
            router.push({name: callBackUrl});
          }
          else {
            console.log("Operation successful", resData.data.responseMessage.responseMessage);
          }
        }
        else if (resData) {
          console.warn("Validation error", resData.data.responseMessage.responseMessage);
        }
        else {
          console.log("No data returned from the request.");
        }
      })
      .catch((err) => {
        console.error("Unexpected error:", err);
      });
};

export const parseErrorMessages = inputString => {
  let outHtml = '';
  const resultArray = inputString.split(', ');
  for (let k = 0; k < resultArray.length; k++) {
    outHtml += '<span class="text text-danger">' + resultArray[k] + '</span><br/>'
  }
  return outHtml;
}

export const postDataWithSweetAlertMessages = ({
                                                 url,
                                                 data,
                                                 noticeMessageTitle = null,
                                                 noticeMessage = null,
                                                 onSuccess = null,
                                                 onError = null,
                                                 onComplete = null,
                                                 resData = null,
                                                 callBackUrl = null,
                                               }) => {
  Swal.fire({
    title: noticeMessageTitle || "Submit this form",
    icon: "question",
    text: noticeMessage || null,
    showCancelButton: true,
    confirmButtonText: "Yes, Go ahead",
    cancelButtonText: "No, cancel!",
    showLoaderOnConfirm: true,
    confirmButtonColor: "#556ee6",
    cancelButtonColor: "#f46a6a",
    reverseButtons: true,
    preConfirm: () => {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        let newHeader = {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('jwt')}`
          }
        };
        axios.post(url, data, newHeader)
            .then((res) => {
              if (typeof onSuccess === 'function') {
                onSuccess(res)
                console.log(JSON.stringify(res, null, 2))
              }
              else {
                // Todo: Remove on production
                Swal.fire({
                  icon: 'error',
                  title: "Error!",
                  text: res.responseMessage,
                }).then(() => {
                  if (typeof onComplete === 'function') {
                    onComplete()
                  }
                });
                console.log(JSON.stringify(res.data, null, 2))
              }
              resData = res.data;
              resolve();
            })
            .catch((error) => {
              if (error.status === 401) {
                console.log('401 received')
                return
              }
              Swal.fire({
                icon: 'error',
                title: "error!",
                text: error.message,
              }).then(() => {
                if (typeof onError === 'function') {
                  onError(error)
                }
              })
              console.log(error.message);
              /*this.isLoading = false;*/
              try {
                // reject(error.message)
              }
              catch (e) {
                console.log(e)
              }
            });
      });
    },
    allowOutsideClick: false,
  }).then(r => {
    console.log('resData', resData)
    if (r.isConfirmed) {
      if (resData.responseCode === "SUCCESS") {
        if (typeof onSuccess === 'function') {
          onSuccess(resData)
        }
        else {
          Swal.fire({
            icon: 'success',
            title: "Success!",
            html: resData.responseMessage,
          }).then(() => {
            if (typeof onComplete === 'function') {
              onComplete()
            }
            else {
              router.push({name: callBackUrl})
            }
          });
        }
      }
      else {
        Swal.fire({
          icon: 'warning',
          title: "Validation error!",
          html: parseErrorMessages(resData.responseMessage),
        }).then(() => {
          if (typeof onComplete === 'function') {
            onComplete()
          }
        });
      }
    }
  });
}

export const postMultipartFormDataWithSweetAlertMessages = ({
                                                              url,
                                                              data,
                                                              noticeMessageTitle = null,
                                                              noticeMessage = null,
                                                              onSuccess = null,
                                                              onError = null,
                                                              onComplete = null,
                                                              resData = null,
                                                              callBackUrl = null,
                                                            }) => {
  Swal.fire({
    title: noticeMessageTitle || "Submit this form",
    icon: "question",
    text: noticeMessage || null,
    showCancelButton: true,
    confirmButtonText: "Yes, Go ahead",
    cancelButtonText: "No, cancel!",
    showLoaderOnConfirm: true,
    confirmButtonColor: "#556ee6",
    cancelButtonColor: "#f46a6a",
    reverseButtons: true,
    preConfirm: () => {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        let newHeader = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
          }
        };
        axios.post(url, data, newHeader)
            .then((res) => {
              if (typeof onSuccess === 'function') {
                onSuccess(res)
                console.log(JSON.stringify(res, null, 2))
              }
              else {
                // Todo: Remove on production
                Swal.fire({
                  icon: 'success',
                  title: "Success!",
                  text: res.responseMessage,
                }).then(() => {
                  if (typeof onComplete === 'function') {
                    onComplete()
                  }
                });
                console.log(JSON.stringify(res.data, null, 2))
              }
              resData = res.data;
              resolve();
            })
            .catch((error) => {
              if (error.status === 401) {
                console.log('401 received')
                return
              }
              Swal.fire({
                icon: 'error',
                title: "error!",
                text: error.message,
              }).then(() => {
                if (typeof onError === 'function') {
                  onError(error)
                }
              })
              console.log(error.message);
              /*this.isLoading = false;*/
              try {
                // reject(error.message)
              }
              catch (e) {
                console.log(e)
              }
            });
      });
    },
    allowOutsideClick: false,
  }).then(r => {
    console.log('resData', resData)
    if (r.isConfirmed) {
      if (resData.responseCode === "SUCCESS") {
        if (typeof onSuccess === 'function') {
          onSuccess(resData)
        }
        else {
          Swal.fire({
            icon: 'success',
            title: "Success!",
            html: resData.responseMessage,
          }).then(() => {
            if (typeof onComplete === 'function') {
              onComplete()
            }
            else {
              router.push({name: callBackUrl})
            }
          });
        }
      }
      else {
        Swal.fire({
          icon: 'warning',
          title: "Validation error!",
          html: parseErrorMessages(resData.responseMessage),
        }).then(() => {
          if (typeof onComplete === 'function') {
            onComplete()
          }
        });
      }
    }
  });
}

export const fetchDataAnonymous = ({url, filters, onSuccess = null, onError = null}) => {
  axios.post(url, filters)
      .then(res => {
        if (typeof onSuccess === 'function') {
          onSuccess(res.data)
        }
        else {
          console.log(res)
        }
      })
      .catch(error => {
        if(error.status === 401) {
          console.log('401 received')
          return
        }
        if (typeof onError === 'function') {
          onError(error)
        }
        else {
          console.log(error);
        }
      });
}

export const getDataAnonymous = ({url, onSuccess = null, onError = null}) => {
  axios.get(url)
      .then(res => {
        if (typeof onSuccess === 'function') {
          onSuccess(res.data)
        }
        else {
          console.log(res)
        }
      })
      .catch(error => {
        if(error.status === 401) {
            console.log('401 Received')
          return
        }
        if (typeof onError === 'function') {
          onError(error)
        }
        else {
          console.log(error);
        }
      });
}

export const processTableRows = (context, res) => {
  if (res.data.length) {
    context.tableColumns = []
    context.tableData = res.data
    context.totalPages = res.totalPages
    context.page = res.currentPage + 1
    context.filters.pageNumber = res.currentPage
    context.totalRecords = res.totalCount
    for (let i in context.tableData[0]) {
      context.exceptions = context.exceptions || {}
      if (!context.exceptions[i]) {
        context.tableColumns.push(i)
      }
    }
    context.noResults = false
  }
  else {
    context.noResults = true
  }
}

export const populateTableRows = (context, data) => {
  if (data.length) {
    console.log(data)
    context.tableColumns = []
    context.tableData = data
    context.totalPages = data.totalPages
    context.page = data.length + 1
    context.filters.pageNumber = data.length
    context.totalRecords = data.length
    for (let i in context.tableData[0]) {
      if (!context.exceptions[i]) {
        context.tableColumns.push(i)
      }
    }
    context.noResults = false
  }
  else {
    context.noResults = true
  }
}

export const formatDateTime = isoString => {
  const date = new Date(isoString);
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  return `${day} ${month}, ${year} ${hours}:${minutes}`;
}

export const formatDateTimeShort = isoString => {
  const date = new Date(isoString);
  const day = date.getUTCDate();
  const month = shortMonths[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  return `${day} ${month}, ${year} ${hours}:${minutes}`;
}

export const formatDate = dateString => {
  const date = new Date(dateString);
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day} ${month}, ${year}`;
}

export const truncateString = (str, maxLength) => {
  // Check if string length exceeds the maxLength
  if (str.length > maxLength) {
    // Truncate the string and add "..." at the end
    return str.slice(0, maxLength) + '...';
  }
  // Return the original string if it's within the limit
  return str;
}

export const formatNumberToString = (value) => {
  if (typeof value === 'string') {
    return value.replace(/,/g, '');
  }
  return value;
}

export const formatNumber = (value) => {
  if (value == null || isNaN(parseFloat(value))) {
    return '';
  }
  return parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const getPaginationPages = totalPages => {
  let p = [];
  for (let i = 1; i <= totalPages; i++) {
    p.push(i)
  }
  return p;
}

export const checkUserHasRequiredPrivilege = requiredPrivileges => {
  if (requiredPrivileges && requiredPrivileges.length) {
    let currentUserPrivileges = JSON.parse(sessionStorage.getItem('privileges')) || [];
    const userPrivilegeValues = currentUserPrivileges.map(privilege => privilege.value);
    return requiredPrivileges.some(privilege => userPrivilegeValues.includes(privilege));
  }
  return true;
};

export const getPropertyFromArrayById = (id, property, array = []) => {
  try {
    const index = array.findIndex(a => a.id === id);
    return array[index][property];
  }
  catch (e) {
    return ''
  }
}

export const truncateText = (text, length) => {
  if (!text) return ''
  return text.length > length ? text.substring(0, length) + '...' : text
}